import React, { useEffect } from "react";
import "../css/aggregates.css";
import "../css/MediaQueries/MediaQueryAggregates.css";
import Lottie from "lottie-react";
import AggregatesAnimationData from "../Lottiefiles/Aggregates 3.json";
import { Row, Col } from "react-bootstrap";
import AggregatesVideo from "../assets/Videos/AGGREGATES (4.57 MB).mp4";
import { Helmet } from "react-helmet";
import FadeInFromLeft from "./animations/FadeInFromLeft"; // Path may need adjusting

export default function AgrregatesPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="Aggregates">
      <Helmet>
        <title>
          Best aggregates construction material supplier in Hyderabad
        </title>
        <meta
          name="description"
          content="Endula has been the best aggregate construction material supplier in hyderabad offering 20mm aggregates, coarse and fine aggreegates for all civil projects."
        />
      </Helmet>

      <div className="fac-hero">
        <div className="heading-wrap fac">
          <h1 className="hero-heading academ-staff" style={{ opacity: 1 }}>
            Aggregates
          </h1>
        </div>
        <div className="arrows-trigger fac"></div>
        <div className="background-noise-new"></div>
        <div className="hero-gradient"></div>
        <div className="hero-img staff"></div>
        <div className="section-anim-trigger"></div>
      </div>
      <section className="section-spacer fac-video"></section>
      <div className="section-wrap staff">
        <section className="section staff">
          <div className="section-cont staff">
            <div className="email-heading staff heading-font">
              Strength in every construction
            </div>
            <div className="email-paragraph staff forSameFonts">
              Endula Infra has been at the forefront of the construction
              materials industry, specializing in producing high-quality
              aggregates.
            </div>

            <div className="d-flex justify-center align-items-center aggr-tab lg:mt-32">
              <div className="email-lottie">
                <Lottie animationData={AggregatesAnimationData} loop={true} />
              </div>
              <div className="section-descr staff forSameFonts">
                Starting with a manufacturing unit in Hyderabad, we have
                expanded our operations in various branches to meet the growing
                demands of the industry. Our commitment to superior standards
                and competitive pricing has made us a trusted name in aggregate
                production. Our leading-edge facility in Hyderabad is equipped
                with advanced machinery and technology to produce a wide range
                of aggregates that meet the highest industry standards.
              </div>
            </div>
          </div>
        </section>
      </div>
      <section className="section-spacer staff"></section>
      <div className="section-wrap email">
        <section className="section email fac3">
          <div className="section-cont email fac3">
            <div className="benefits-heading">
              <h2>Advantages of Aggregates</h2>
            </div>
            <div className="d-flex">
              <Row>
                <Col
                  lg={6}
                  className="d-flex justify-content-center align-items-center"
                >
                  <div className="benefits-img-wrap">
                    <video autoPlay loop muted playsInline>
                      <source src={AggregatesVideo} />
                    </video>
                  </div>
                </Col>

                <Col lg={6}>
                  <FadeInFromLeft delay={200}>
                    <div className="fairs-row heading-font">
                      <div className="fairs-bullet"></div>
                      <div>
                        <h6>Superior load-bearing capacity</h6>
                        <p className="forSameFonts">
                          Our metal aggregates, particularly the 20mm and 40mm
                          sizes offer excellent load-bearing capacity, making
                          them ideal for heavy-duty construction work.
                        </p>
                      </div>
                    </div>
                  </FadeInFromLeft>

                  <FadeInFromLeft delay={400}>
                    <div className="fairs-row heading-font">
                      <div className="fairs-bullet"></div>
                      <div>
                        <h6>Excellent binding properties</h6>
                        <p className="forSameFonts">
                          Aggregates like our 10mm metal provide superior
                          binding, ensuring strong adhesion in concrete mixes
                          and enhanced structural integrity.
                        </p>
                      </div>
                    </div>
                  </FadeInFromLeft>

                  <FadeInFromLeft delay={600}>
                    <div className="fairs-row heading-font">
                      <div className="fairs-bullet"></div>
                      <div>
                        <h6>Versatility</h6>
                        <p className="forSameFonts">
                          From fine plaster sand to robust 40mm metal, our range
                          of products caters to various construction needs,
                          making Endula Infra a one-stop solution for all
                          aggregate requirements.
                        </p>
                      </div>
                    </div>
                  </FadeInFromLeft>

                  <FadeInFromLeft delay={800}>
                    <div className="fairs-row heading-font">
                      <div className="fairs-bullet"></div>
                      <div>
                        <h6>Environmental responsibility</h6>
                        <p className="forSameFonts">
                          Our crushed rock fine is an environmentally friendly
                          alternative to natural sand, promoting sustainable
                          construction practices.
                        </p>
                      </div>
                    </div>
                  </FadeInFromLeft>
                </Col>
              </Row>
            </div>
          </div>
        </section>
      </div>

      <div className="section-spacer email"></div>
    </div>
  );
}
